import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

interface Props {
  className?: string | undefined;
  onClick?: any;
  $isMobile: boolean;
}

export const ButtonFooter = styled.div<Props>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  label {
    margin-top: 5px;
    font-family: ${customTheme.fonts.body};
    font-weight: 500;
    font-size:  ${({ $isMobile }) => $isMobile ? customTheme.fontSizes.xs : '0.700rem'};
    text-align: center;
    cursor: pointer;

  }

  ${({ $isMobile }) => !$isMobile && ('padding: 10px 0;')}


  ${({ $isMobile }) => !$isMobile && (
  `
    &:hover {
      background-color: ${customTheme.colors.gray['800']};
    }
  `)}
  
`
